/* @flow */
import React from 'react';

import Row from 'components/UIKit/Flex/Row';
import Button from './Button';

export default function ButtonTemplate({
  children, style, PrefixComponent, PostfixComponent, customDataTestID, ...rest
}: any): React.Element {
  return (
    <Button customDataTestID={customDataTestID} style={style} {...rest}>
      <Row style={{ alignItems: 'center', justifyContent: 'center' }}>
        { PrefixComponent }
        { children }
        { PostfixComponent }
      </Row>
    </Button>
  );
}
